import { render, staticRenderFns } from "./StudyingCertificate.vue?vue&type=template&id=3541922c&"
import script from "./studyingcertificate.js?vue&type=script&lang=js&"
export * from "./studyingcertificate.js?vue&type=script&lang=js&"
import style0 from "./StudyingCertificate.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports